<template>
	<div class="form__group">
		<multiselect :options="options" :placeholder="placeholder" :allow-empty="allowEmpty" label="label" track-by="id"
		             :searchable="false" :multiple="multiple" :show-labels="false" v-model="selected"
		             :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }">>
		</multiselect>

		<label class="form__label">Currency</label>
		<div class="form__validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import Select from './Select';

	export default {
		name: 'FormControlCurrency',
		mixins: [Select],
		props: {
			placeholder: {
				type: String,
				default: 'Select currency...',
			}
		},
		data() {
			return {
				options: [
					{
						label: 'USD',
						id: 1,
					},
					{
						label: 'GBP',
						id: 2,
					},
					{
						label: 'EUR',
						id: 3,
					},
				],
			}
		},
	}
</script>

